import Model from './Model';

export default class WatchedUntilTime extends Model {
  resource() {
    return 'watched_until';
  }
}
